<template>
  <!-- 主路由内容 -->
  <div v-if="isMainRoute" class="contact-main-layout">
    <!-- 使用Banner组件 -->
    <Banner :banner-list="bannerList" :accordion-items="accordionItems" />
  </div>

  <!-- 子路由内容 -->
  <div v-else class="layout-container">
    <div class="sidebar">
      <el-menu :router="true" :default-active="normalizedRoutePath">
        <el-menu-item index="/contact/recruit">
          {{ t("pages.contact.recruit.menuTitle") }}
        </el-menu-item>
        <el-menu-item index="/contact/postdoc">
          {{ t("pages.contact.postdoc.menuTitle") }}
        </el-menu-item>
        <el-menu-item index="/contact/info">
          {{ t("pages.contact.info.menuTitle") }}
        </el-menu-item>
      </el-menu>
    </div>
    <div class="content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import { createI18n } from 'vue-i18n';
import { useRoute, useRouter } from "vue-router";
import { computed, ref } from "vue";
import Banner from "@/components/Home/Banner.vue";
import zhData from '../../i18n/zh';
import enData from '../../i18n/en';
import { useLangStore } from '../../pinia/stores/lang';
import i18n from '../../i18n';

export default {
  name: 'ContactView',
  components: { Banner },
  setup() {
    const { t } = i18n.global;
    const route = useRoute();
    const router = useRouter();
    const langStore = useLangStore();
    const normalizedRoutePath = computed(() => {
      return route.path.replace(/^\/(zh|en)(?=\/|$)/i, '') || '/';
    });

    // 根据当前语言选择对应的翻译数据
    const translationData = computed(() => {
      return langStore.currentLang.startsWith('zh') ? zhData : enData;
    });

    // 判断是否是主路由
    const isMainRoute = computed(() => {
      return normalizedRoutePath.value === "/contact" || normalizedRoutePath.value === "/contact/";
    });

    // 配置Banner组件的banner列表
    const bannerList = ref([
      {
        image: "/images/homebanner/Banner01.jpg",
        title: "联系我们", // 或者使用 i18n
        titleAnimation: "fade-in-down",
        descAnimation: "fade-in-up",
      },
    ]);

    // 配置AccordionSection组件的内容项 (用于主路由 /contact)
    const accordionItems = ref([
      {
        title: "pages.contact.postdoc.accordionTitle",
        content: "",
        image: "/images/postdoc-accordion.jpg", // 替换为博士后相关的图片
        link: "/contact/postdoc",
      },
      {
        title: "pages.contact.info.accordionTitle",
        content: "",
        image: "/images/postdoc-accordion.jpg", // 替换为博士后相关的图片
        link: "/contact/info",
      },
    ]);

    return {
      t,
      route,
      router,
      normalizedRoutePath,
      isMainRoute,
      bannerList,
      accordionItems
    };
  }
};
</script>

<style scoped lang="scss">
// 子路由布局样式
.layout-container {
  display: flex;
  padding: 100px 40px 40px;
  max-width: 1400px;
  margin: 0 auto;
  gap: 40px;

  .sidebar {
    width: 280px;
    flex-shrink: 0;
  }

  .content {
    flex: 1;
    min-width: 0;
  }
}

// 主路由布局样式
.contact-main-layout {
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

@media screen and (max-width: 768px) {
  .layout-container {
    flex-direction: column;
    padding: 80px 20px 20px;
    gap: 20px;
    align-items: center;

    .sidebar {
      display: none;
    }

    .content {
      width: 100%;
      max-width: 800px;
      text-align: center;
    }
  }
}
</style>
